import { render, staticRenderFns } from "./DiagnosticsInfoReport.vue?vue&type=template&id=2dade9a0&"
import script from "./DiagnosticsInfoReport.vue?vue&type=script&lang=js&"
export * from "./DiagnosticsInfoReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports